exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-1[data-v-b6c7b8f6] {\n  border: 1px solid #dadada\n}\n.artist-list[data-v-b6c7b8f6] {\n  gap: 5px;\n}\n.selected-artist-name-text[data-v-b6c7b8f6]:hover,.remove-icon[data-v-b6c7b8f6]:hover {\n  color: #ff2289;\n}\n", ""]);

// exports
